/**
 * Shared sizing for an agent's photo inside a round avatar frame.
 *
 * Agent photos are self-supplied and mostly migrated from erp213 — WhatsApp
 * snaps, studio half-body shots, name-card artwork, and a fair number of
 * full-length standing portraits as tall as 1:2. `object-fit: cover` on a
 * square frame keeps the middle of the image, and the middle of a standing
 * portrait is the jacket: the avatar introduces the agent by their torso, with
 * the face cropped off entirely.
 *
 * `object-position: center 15%` anchors the crop near the top, where a face
 * actually sits, instead of the geometric centre. 15% rather than `top`
 * because the tall photos are the minority — pinning everything hard to the
 * top leaves most head-and-shoulders shots floating under a band of headroom.
 * 15% was the deepest anchor that still kept the whole head on every sampled
 * photo; past ~20% the tightest-framed portraits start losing the forehead.
 *
 * Only portrait images are affected. On a square or landscape photo the cover
 * scale is driven by height, so there is no vertical overflow to position and
 * the value is a no-op — the horizontal stays centred either way.
 *
 * This does NOT rescue a full-length shot where the agent stands head-to-toe
 * in frame: the face is simply small there, and no crop anchor can zoom. Those
 * need a re-upload (or a face-aware thumbnail at upload time).
 */
export const AVATAR_IMG = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center 15%',
};
